/**
 * Map Component
 * 
 * This component renders an embedded map inside a styled MUI Box using an <iframe>.
 * The map is sourced from "https://map.tabaqat.net/", which is likely a custom GIS map.
 * 
 * The Box component is styled to fit the full width and almost the full height of the viewport,
 * with padding and border radius for UI consistency.
 */

import { Box } from "@mui/material";

// Functional component to display the embedded map
const Map = () => {
  return (
    <Box sx={boxStyle}>
      {/* Embedded iframe for the Tabaqat map */}
      <iframe
        title="map" // Accessibility title
        src="https://map.tabaqat.net/" // URL to the map source
        height="100%" // Full height of the Box
        width="100%" // Full width of the Box
      ></iframe>
    </Box>
  );
};

export default Map;

// Styling for the Box container
const boxStyle = {
  background: "white", // White background to frame the map
  width: "100%", // Full width of the parent
  minHeight: "300px", // Minimum height to ensure visibility on small screens
  height: "calc(100vh - 120px)", // Responsive height calculation (adjusts with viewport)
  borderRadius: "20px" , //  border Radius
  overflow: "hidden" // Prevent iframe content from overflowing the Box
};
